<template>
  <transition name="fade">
    <div
      class="video-cover"
      v-if="show"
      :style="{ backgroundImage: `url('${coverUrl}')` }"
    >
      <v-layout
        align-center
        justify-center
        fill-height
        row
        :column="$vuetify.breakpoint.smAndDown"
      >
        <v-hover>
          <v-icon
            slot-scope="{ hover }"
            :color="hover ? 'grey darken-3' : 'grey darken-2'"
            class='my-circle'
            size="150"
            @click="selectVideoFile"
            :elevation="hover ? 10 : 2"
          >
            play_arrow
          </v-icon>
        </v-hover>
      </v-layout>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import { isWebkit } from '@/utils/platform';
import EventBus from '@/EventBus';

export default {
  data() {
    return {
    };
  },
  components: {
  },
  computed: {
    ...mapState([
      'project',
      'playbackStarted'
    ]),
    show() {
      return !(this.$store.state.playbackStarted);
    },
    contenttype() {
      const { project } = this.$store.state;
      const type = (project && project.content) ? project.content : null;
      return type;
    },
    dash() {
      const { project } = this.$store.state;
      const url = (project && project.dash) ? project.dash : null;
      return url;
    },
    file() {
      const { project } = this.$store.state;
      const url = (project && project.file) ? project.file : null;
      return url;
    },
    coverUrl() {
      return this.$store.state.project.coverUrl || '../img/default_cover.jpg';
    },
  },
  methods: {
    selectVideoFile() {
      // Show spinner
      this.$store.commit('appState', 'LOADING');

      // Create adaptive stream if available
      if (this.dash) {
        this.createPlayer('stream', this.dash, 'auto');
      // Create medium quality video If iOS device and file available
      } else if (isWebkit()) {
        if (this.$store.state.project.medium) {
          this.createPlayer('video', this.$store.state.project.medium, 'medium');
        } else if (this.$store.state.project['720p']) {
          this.createPlayer('video', this.$store.state.project['720p'], '720p');
        // Use original file if medium quality is not available
        } else {
          this.createPlayer(this.contenttype, this.file, 'original file');
        }
      // Use original file for other devices
      } else {
        this.createPlayer(this.contenttype, this.file, 'original file');
      }
    },
    createPlayer(type, url, quality) {
      // MOV file not supported
      if (this.isMov(url)) {
        const msg = 'MOV video format is not supported. Please select other quality.';
        EventBus.$emit('reader-dialog', { type: 'warning', title: 'Format not supported', text: msg });
      } else {
        this.$player.createPlayer(type, url);
      }
      // Update selected quality marker
      this.$store.commit('selectedQuality', quality);
    },
    play() {
      this.$player.play();
    },
    isMov(url) {
      return url.includes('.mov');
    },
  },
};
</script>

<style scoped>
.video-cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 21;
  background-size: cover;
}
.video-cover2 {
  z-index: 21;
  background-size: cover;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.my-circle {
  background-color: rgba(158,158,158,1);
  border-radius: 75px;
}
</style>
